module.exports = __webpack_public_path__ + "img/arrival_12.c2044017.jpg";